export function OutlinePencilIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6302 5.16034L4.08154 15.709L8.3037 19.9311L18.8523 9.38249L14.6302 5.16034Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1973 3.40289L20.6137 4.81927C21.3893 5.5949 21.3893 6.84941 20.6137 7.62505L18.85 9.38877L14.6278 5.16662L16.3915 3.40289C17.1672 2.62725 18.4217 2.62725 19.1973 3.40289Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.30368 19.9364L8.29415 19.946L3.01465 21L4.06864 15.7205L4.07818 15.7109L8.30368 19.9364Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
